var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u0421\\u043B\\u043E\\u0439_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 26 23.6",
    style: {
      enableBackground: "new 0 0 26 23.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#1E2224;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\\u0421\\u043B\\u043E\\u0439_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M15,23.6c-0.9,0-2.1-0.5-3.8-1.1c-1.2-0.5-1.9-0.7-2.3-1.4c-0.5-0.7-0.5-1.4-0.5-2.6v-3.2c0-0.7,0-1.1-0.1-1.4 C8.3,13.4,8,13,7.6,12.6c-0.2-0.2-0.6-0.4-1.3-0.8l-3.5-2C1.6,9.1,0.9,8.8,0.4,8C0,7.3,0,6.5,0,5.2V4.3c0-1.8,0-2.8,0.8-3.6 C1.6,0,2.7,0,4.5,0h16.9c1.9,0,2.9,0,3.7,0.7C26,1.5,26,2.6,26,4.3v0.8c0,1.4,0,2.1-0.4,2.9c-0.4,0.7-1.1,1.1-2.4,1.8l-3.5,2 c-0.7,0.4-1.1,0.6-1.3,0.8c-0.4,0.4-0.7,0.8-0.8,1.3c0,0.2,0,0.6,0,1.4v3.2c0,2.6,0,4-1.2,4.7C15.9,23.5,15.5,23.6,15,23.6L15,23.6 z M4.5,1.8c-1.3,0-2.2,0-2.5,0.2c-0.2,0.2-0.2,1-0.2,2.2v0.8c0,1.1,0,1.6,0.2,1.9c0.2,0.3,0.7,0.6,1.7,1.2l3.5,2 c0.8,0.5,1.2,0.7,1.6,1c0.7,0.6,1.2,1.4,1.4,2.3c0.1,0.4,0.1,0.9,0.1,1.8v3.2c0,0.9,0,1.4,0.1,1.5c0.1,0.2,0.7,0.4,1.5,0.7 c1.8,0.7,3,1.2,3.4,0.9c0.4-0.2,0.4-1.5,0.4-3.2v-3.2c0-0.9,0-1.3,0.1-1.8c0.2-0.9,0.7-1.7,1.4-2.3c0.4-0.3,0.8-0.5,1.6-1l3.5-2 c1-0.6,1.5-0.8,1.7-1.2c0.2-0.3,0.2-0.8,0.2-1.9V4.3c0-1.2,0-2-0.2-2.2c-0.3-0.2-1.1-0.2-2.5-0.2L4.5,1.8L4.5,1.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.ce3df375f2c8dde08ec2e089f38877c4.svg";
export { ForwardRef as ReactComponent };